import zhCN from './json/announcement.zh_CN.json';
import zhTW from './json/announcement.zh_TW.json';
import en from './json/announcement.en.json';
import ja from './json/announcement.ja.json';
import ko from './json/announcement.ko.json';
import ru from './json/announcement.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
